<template>
  <div>
    <p>NotFound</p>
    <router-link to="/login">ログイン画面へ</router-link>
  </div>
</template>

<script>
  export default {};
</script>
